import { render, staticRenderFns } from "./left3.vue?vue&type=template&id=55a91ebd&"
import script from "./left3.vue?vue&type=script&lang=js&"
export * from "./left3.vue?vue&type=script&lang=js&"
import style0 from "./left3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports